import './warranty-modal.scss';
import './warranty-checkout.scss';
import {ParameterValidator} from '@mvps-genesis/utilities';
import tippy from 'tippy.js';
import RobodogPicker from '../../Transloadit/transloadit.js';
import MicroModal from 'micromodal';
import EventBus from '@mvps-genesis/event-bus';
import Swiper from 'swiper/bundle';

export default class WarrantyCheckout {

	// eslint-disable-next-line max-lines-per-function
	constructor () {
		const self = this;

		self.validator = new ParameterValidator(self);

		self.errorLabelClass = 'has-error';
		self.errorClass = 'u-font-small';
		self.wrapperSelector = '.js-warranty-validator';

		self.modalElement = self.validator.isElement('modal', '#modal-warranty-checkout', {required: false});
		self.form = self.validator.isElement('form', '#js-modal-warranty-checkout-form', {required: false});
		self.uploadElem = self.validator.isElement('uploadElem', '#js-warranty-checkout-invoice-upload', {required: false});
		self.toolTips = self.validator.isElementList('toolTips', '.js-warranty-tooltip', {required: false});
		self.sliderElem = self.validator.isElement('sliderElem', '#js-warranty-checkout-slider', {required: false});
		self.hasSlider = self.slider ? 1 : 0;
		self.sliderBackElems = self.validator.isElementList('sliderBackElems', '.js-warranty-checkout-back', {required: false});
		self.sliderNextElems = self.validator.isElementList('sliderNextElems', '.js-warranty-checkout-next', {required: false});

		self.robodog = new RobodogPicker();


		if (self.form) {
			self.formElementsWrapper = self.form.querySelectorAll(self.wrapperSelector);
		}

		// Map object for default error messages
		self.messageMap = {
			DEFAULT: 'Please enter a value',
			INPUT_CHECKBOX: 'Please check the checkbox',
			INPUT_DATE: 'Please enter a valid date',
			INPUT_EMAIL: 'Please enter a valid email',
			INPUT_FILE: 'Please select a valid file',
			INPUT_NUMBER: 'Please enter a valid number',
			INPUT_PASSWORD: 'Please enter a valid password',
			INPUT_RADIO: 'Please select an option',
			INPUT_RANGE: 'Please select a range',
			INPUT_SEARCH: 'Please enter a value',
			INPUT_TEL: 'Please enter a valid telephone number',
			INPUT_TEXT: 'Please enter a value',
			INPUT_URL: 'Please enter a valid URL',
			SELECT: 'Please select an option',
			TEXTAREA: 'Please enter a value'
		};

		self.fields = [];

		self.bindEvents();

		EventBus.addEventListener('MiniModal:onClose', function (e) {
			self.modalOnHide(e);
		});
	}

	modalOnHide (e) {
		if (e.detail.id === 'modal-warranty-checkout' && document.body.classList.contains('uppy-Dashboard-isFixed')) {
			setTimeout(() => {
				MicroModal.show(e.detail.id, {
					awaitCloseAnimation: true,
					awaitOpenAnimation: true,
					disableScroll: true,
					onClose: modal => EventBus.dispatchEvent('MiniModal:onClose', modal),
					onShow: modal => EventBus.dispatchEvent('MiniModal:onShow', modal)
				});
			}, 400);
		}
	}

	bindEvents () {
		if (this.form) {
			this.form.addEventListener('submit', (e) => this.validateForm(e));
		}

		if (this.formElementsWrapper) {
			for (const wrapper of this.formElementsWrapper) {
				this.bindInputWrapper(wrapper);
			}
		}

		if (this.toolTips) {
			for (const tooltip of this.toolTips) {
				this.createTooltip(tooltip);
			}
		}

		if (this.uploadElem) {
			this.uploadElem.addEventListener('click', () => this.uploadTrigger());
		}

		if (this.sliderElem) {
			this.bindSliderEvents();
		}
	}

	bindSliderEvents () {
		const self = this;

		self.slider = new Swiper(self.sliderElem, {
			allowSlideNext: false,
			allowSlidePrev: false,
			allowTouchMove: false,
			effect: 'fade',
			navigation: false,
			noSwiping: true,
			observeParents: true,
			observer: true,
			preventClicks: false,
			preventClicksPropagation: false,
			slidesPerView: 1,
			spaceBetween: 0,
			speed: 325,
			touchStartPreventDefault: false
		});

		self.slider.on('slideChangeTransitionEnd', () => {
			self.slider.update();
		});

		if (self.sliderNextElems) {
			for (const nextElem of self.sliderNextElems) {
				nextElem.addEventListener('click', () => self.slideNext());
			}
		}

		if (self.sliderBackElems) {
			for (const backElem of self.sliderBackElems) {
				backElem.addEventListener('click', () => self.slidePrev());
			}
		}
	}

	slideNext () {
		if (!this.slider) {
			return;
		}

		this.validateSlideFormElements();

		const currentSlide = this.slider.slides[this.slider.activeIndex];
		let errors = [];

		if (currentSlide) {
			errors = currentSlide.getElementsByClassName(this.errorLabelClass);
		} else {
			errors = this.form.getElementsByClassName(this.errorLabelClass);
		}

		if (errors.length) {
			return;
		}

		this.slider.allowSlideNext = true;
		this.slider.slideNext();
		this.slider.allowSlideNext = false;
	}

	slidePrev () {
		if (!this.slider) {
			return;
		}

		this.slider.allowSlidePrev = true;
		this.slider.slidePrev();
		this.slider.allowSlidePrev = false;
	}

	bindInputWrapper (elem) {
		if (elem.classList.contains('js-has-character-limit')) {
			this.bindCharacterLimitInputs(elem);
		}

		if (elem.classList.contains('js-date-of-purchase')) {
			this.bindDateOfPurchaseInputs(elem);
		}

		this.bindInputs(elem);
	}

	bindCharacterLimitInputs (elem) {
		const maxCharactersElem = elem.querySelector('.js-character-limit');

		if (!maxCharactersElem) {
			return;
		}

		const countElem = elem.querySelector('.js-character-limit-count');
		const input = elem.querySelector('#' + maxCharactersElem.getAttribute('data-field-id'));
		const max = parseFloat(maxCharactersElem.getAttribute('data-max'));

		if (input) {
			input.addEventListener('keyup',		() => this.updateCharacterCount(input, countElem, max));
			input.addEventListener('keypress',	() => this.updateCharacterCount(input, countElem, max));
			input.addEventListener('change',	() => this.updateCharacterCount(input, countElem, max));
			input.addEventListener('keydown',	() => this.updateCharacterCount(input, countElem, max));
			input.addEventListener('blur',		() => this.updateCharacterCount(input, countElem, max));

			// Initiate on Load
			this.updateCharacterCount(input, countElem, max);
		}
	}

	updateCharacterCount (input, countElem, max) {
		input.value = input.value.substring(0, max);
		const length = input.value.length;
		countElem.innerText = length;
	}

	bindDateOfPurchaseInputs (elem) {
		const warningElem = elem.querySelector('[data-warninghook]');

		if (!warningElem) {
			return;
		}

		const input = elem.querySelector('#' + warningElem.getAttribute('data-field-id'));

		if (input) {
			input.addEventListener('keyup',		() => this.updateDateOfPurchaseWarning(input, warningElem));
			input.addEventListener('keypress',	() => this.updateDateOfPurchaseWarning(input, warningElem));
			input.addEventListener('change',	() => this.updateDateOfPurchaseWarning(input, warningElem));
			input.addEventListener('keydown',	() => this.updateDateOfPurchaseWarning(input, warningElem));
			input.addEventListener('blur',		() => this.updateDateOfPurchaseWarning(input, warningElem));


			// Initiate on Load
			this.updateDateOfPurchaseWarning(input, warningElem);
		}
	}

	updateDateOfPurchaseWarning (input, warningElem) {
		if (!input.value) {
			this.showDateOfPurchaseWarning(warningElem, false);
			return;
		}

		const date = new Date(input.value);
		const timestamp = date.getTime() / 1000;
		const fiveYearsPrior = new Date(Date.now());
		fiveYearsPrior.setHours(0, 0, 0, 0);
		fiveYearsPrior.setFullYear(fiveYearsPrior.getFullYear() - 5);
		const fiveYearsAgo = fiveYearsPrior.getTime() / 1000;

		this.showDateOfPurchaseWarning(warningElem, timestamp <= fiveYearsAgo);
	}

	showDateOfPurchaseWarning (warningElem, show) {
		if (show) {
			warningElem.classList.remove('u-hidden');
			return;
		}

		warningElem.classList.add('u-hidden');
	}

	validateInputs (elem) {
		const inputs = elem.querySelectorAll('[required], [pattern]');

		for (const input of inputs) {
			this.validateFormElement(input);
		}
	}

	bindInputs (elem) {
		const inputs = elem.querySelectorAll('[required], [pattern]');

		for (const input of inputs) {
			this.bindInput(input);
		}
	}

	bindInput (elem) {
		if (elem.type === 'radio' || elem.type === 'checkbox' || elem.type === 'input') {
			elem.addEventListener('change', (e) => this.validateFormElement(elem, e));
		} else {
			elem.addEventListener('input', (e) => this.validateFormElement(elem, e));
			elem.addEventListener('blur', (e) => this.validateFormElement(elem, e));
		}
	}

	validateFormElement (element, event) {
		// Validate argument
		if (!element || element instanceof window.HTMLElement === false) {
			throw new Error('validateFormElement requires a valid DOM element');
		}

		if (element.offsetParent === null) {
			return true;
		}

		if (element.validity.valid) {
			this.toggleError(element, 'hide');
			return true;
		}

		// eslint-disable-next-line no-mixed-operators
		if (!event || event && event.type === 'blur') {
			this.toggleError(element, 'show');
		}

		return false;

	}

	toggleError (element, action) {
		let actionVal = action === 'show' || action === 'hide' ? action : null;
		let inlineErrorContainer = '';
		let wrapper = '';

		// Validate arguments
		if (!element || element instanceof window.HTMLElement === false || !action) {
			throw new Error('toggleError requires a valid DOM element and an action of "show" or "hide"');
		}

		// Grab needed elements
		wrapper = element.closest(this.wrapperSelector);

		if (!wrapper) {
			throw new Error('toggleError requires a valid wrapper element');
		}

		inlineErrorContainer = wrapper.querySelector('[data-errorhook]');

		// Toggle appropriate classes and error messages
		if (actionVal === 'show') {
			wrapper.classList.add(this.errorLabelClass);
			if (inlineErrorContainer) {
				inlineErrorContainer.classList.remove('u-hidden');
			} else {
				// Create an error message if one does not exist yet
				inlineErrorContainer = this.createInlineErrorContainer(element);
				if (inlineErrorContainer.textContent.length !== 0) {
					wrapper.appendChild(inlineErrorContainer);
				}
			}
		} else {
			wrapper.classList.remove(this.errorLabelClass);
			if (inlineErrorContainer) {
				inlineErrorContainer.classList.add('u-hidden');
			}
		}
	}

	createInlineErrorContainer (element) {
		let elementType = '';
		let errorElement = document.createElement('div');
		let errorMessage = '';

		// Validate arguments
		if (!element || element instanceof window.HTMLElement === false) {
			return errorElement;
		}

		// Build the message
		if (element.hasAttribute('data-errormessage')) {
			// Custom error message
			errorMessage = element.getAttribute('data-errormessage');
		} else if (element.hasAttribute('title')) {
			// Custom error message from title
			errorMessage = element.getAttribute('title');
		} else {
			// Canned message based on type of element
			elementType = element.tagName;
			if (elementType === 'INPUT') {
				elementType += '_' + element.getAttribute('type').toUpperCase();
			}
			errorMessage = this.messageMap[elementType] || this.messageMap.DEFAULT;
			// Add min and max values to errorMessage
			if (elementType === 'INPUT_NUMBER') {
				let min = element.getAttribute('min');
				let max = element.getAttribute('max');

				if (min) {
					errorMessage += ', minimum: ' + min;
				}

				if (max) {
					errorMessage += ', maximum: ' + max;
				}
			}
		}

		// Add class and message to error element
		errorElement.className = this.errorClass;
		errorElement.textContent = errorMessage;
		errorElement.setAttribute('data-errorhook', true);

		// Return the element to the calling method
		return errorElement;
	};

	validateForm (e) {
		if (this.slider) {
			this.validateSlideFormElements();
		} else {
			this.validateAllFormElements();
		}

		const errors = this.form.getElementsByClassName(this.errorLabelClass);

		if (errors.length) {
			e.preventDefault();
		}
	}

	validateSlideFormElements () {
		const currentSlide = this.slider.slides[this.slider.activeIndex];

		if (!currentSlide) {
			return;
		}

		const formElementsWrapper = currentSlide.querySelectorAll(this.wrapperSelector);
		if (formElementsWrapper) {
			for (const wrapper of formElementsWrapper) {
				this.validateInputs(wrapper);
			}
		}
	}

	validateAllFormElements () {
		if (this.formElementsWrapper) {
			for (const wrapper of this.formElementsWrapper) {
				this.validateInputs(wrapper);
			}
		}
	}

	createTooltip (elem) {
		tippy(elem, {
			appendTo: 'parent',
			arrow: true,
			interactive: true,
			maxWidth: 350,
			placement: 'top',
			theme: 'basic-tooltip',
			zIndex: 2
		});
	}

	uploadTrigger () {
		this.robodog.openPicker();
	}
}
